import React from 'react';
import classnames from 'classnames';
import Collapsible from 'react-collapsible';
import CheckBox from '../../../../../componentes/checkbox/checkbox.component';
import {
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Card,
	CardBody,
	CardTitle,
	CardText,
	FormGroup,
	Label,
	Input,
	Button,
	Nav,
	NavItem,
	NavLink,
	TabContent,
	TabPane,
	Row,
	Col,
	Badge,
} from 'reactstrap';
import ModalJustificativaCancelamento from './modal.justificativa.cancelamento';
import IntlMessage from '../../../../../helpers/intlMessage';

export const ModalEntregaPage = (props) => (
	<div className="mv-container-entrega">
		{props.showModalCancelamentoEntrega && (
			<ModalJustificativaCancelamento
				toggleModalCancelamentoEntrega={props.toggleModalCancelamentoEntrega}
				showModalCancelamentoEntrega={props.showModalCancelamentoEntrega}
				setJustificativaCancelamentoEntrega={
					props.setJustificativaCancelamentoEntrega
				}
				justificativaCancelamentoEntrega={
					props.justificativaCancelamentoEntrega
				}
				cancelarEntrega={props.cancelarEntrega}
			/>
		)}
		<Modal
			size="lm"
			isOpen={props.openModalMaterial}
			toggle={props.closeModalMaterial}
		>
			<ModalHeader toggle={props.closeModalMaterial}>
				<IntlMessage id="dashboard.resultsScreen.modal.selectdelivereditems" />
			</ModalHeader>
			<ModalBody>
				<div
					className="mv-entrega-container"
					style={{
						/* height: `${props.altura}px`, */ height: '450px',
						overflowY: 'scroll',
						overflowX: 'hidden',
					}}
				>
					{props.blocos.length > 0 && (
						<Label>
							<IntlMessage id="dashboard.resultsScreen.modal.block" />
						</Label>
					)}

					{props.blocos.map((b) => {
						return (
							<CheckBox
								label={b.numeroBloco}
								onChange={() => props.checkMaterial('blocos', b)}
								checked={b.checked}
								disabled={b.entregue}
							></CheckBox>
						);
					})}

					{props.laminas.length > 0 && (
						<Label>
							<IntlMessage id="dashboard.resultsScreen.modal.sheets" />
						</Label>
					)}

					{props.laminas.map((l) => {
						return (
							<CheckBox
								label={l.label}
								onChange={() => props.checkMaterial('laminas', l)}
								checked={l.checked}
								disabled={l.entregue}
							></CheckBox>
						);
					})}
				</div>
			</ModalBody>
			<ModalFooter>
				<Button color="secondary" onClick={props.closeModalMaterial}>
					<IntlMessage id="dashboard.resultsScreen.modal.canceled" />
				</Button>

				<Button color="primary" onClick={props.entregarExame}>
					<IntlMessage id="dashboard.resultsScreen.modal.confirm" />
				</Button>
			</ModalFooter>
		</Modal>
		<Modal size="lg" isOpen={props.openModalEntrega} toggle={props.closeModal}>
			<ModalHeader toggle={props.closeModal}>
				<IntlMessage id="dashboard.resultsScreen.modal.deliveryofexams" />
			</ModalHeader>
			<ModalBody>
				<Nav tabs>
					<NavItem>
						<NavLink
							className={classnames({ active: props.activeTab === '1' })}
							onClick={() => {
								props.changeAba('1');
							}}
						>
							<IntlMessage id="dashboard.resultsScreen.modal.carryoutdelivery" />
						</NavLink>
					</NavItem>
					<NavItem style={{ position: 'relative' }}>
						<NavLink
							className={classnames({ active: props.activeTab === '2' })}
							onClick={() => {
								props.changeAba('2');
							}}
						>
							<IntlMessage id="dashboard.resultsScreen.modal.history" />
						</NavLink>
					</NavItem>
				</Nav>
				<TabContent activeTab={props.activeTab}>
					<TabPane tabId="1">
						<Row>
							<Col>
								<FormGroup>
									<Label>
										<IntlMessage id="dashboard.resultsScreen.modal.deliveredto" />
									</Label>
									<Input
										name="exameEntregueA"
										onChange={props.modalOnChangeTexto}
									/>
								</FormGroup>
							</Col>
							<Col sm="4">
								<FormGroup>
									<Label>
										<IntlMessage id="dashboard.resultsScreen.modal.cpf" />
									</Label>
									<Input
										name="cpfResponsavel"
										onChange={props.modalOnChangeTexto}
										value={props.cpfResponsavel}
									/>
									{props.cpfValido && (
										<i className="far fa-check-circle cfp-valido"></i>
									)}
									{props.cpfResponsavel &&
										props.cpfResponsavel.length === 14 &&
										!props.cpfValido && (
											<i className="fas fa-times cfp-invalido"></i>
										)}
								</FormGroup>
							</Col>
						</Row>
						<FormGroup>
							<Label>
								<IntlMessage id="dashboard.resultsScreen.modal.notes" />:
							</Label>
							<Input
								type="textarea"
								name="anotacoesEntregaExame"
								onChange={props.modalOnChangeTexto}
								maxLength={300}
							/>
						</FormGroup>
						<FormGroup>
							<Label>
								<IntlMessage id="dashboard.resultsScreen.modal.internalnotes" />
							</Label>
							{'  '}
							<Label style={{ color: '#d41a1a', fontSize: '0.6rem' }}>
								<IntlMessage id="dashboard.resultsScreen.modal.noteswillnotbeincludedinthedeliveryprotocol" />
							</Label>
							<Input
								type="textarea"
								name="anotacoesInternasEntregaExame"
								onChange={props.modalOnChangeTexto}
								maxLength={300}
							/>
						</FormGroup>
						{props.documentosExternos &&
							props.documentosExternos.length > 0 && (
								<FormGroup>
									<Label>
										<IntlMessage id="dashboard.resultsScreen.modal.externaldocumentreturnedpatient" />
									</Label>
									<div>
										<ul className="ul-sem-estilo">
											{props.documentosExternos.map((doc) => {
												let dataEntrega = !!doc.entregue
													? ` ; entregue em ${doc.dataSaidaDocumento}`
													: '';

												return (
													<li key={doc.id}>
														<CheckBox
															checkmarkClassName={
																!!doc.entregue
																	? ' checkmark-disable'
																	: undefined
															}
															disabled={!!doc.entregue}
															label={`${doc.nomeDocumento} ${dataEntrega}`}
															checked={
																props.checkedDocumentosExternos.findIndex(
																	(ee) => ee === doc.id
																) >= 0
															}
															onChange={() => props.onChangeDocExterno(doc.id)}
														/>
													</li>
												);
											})}
										</ul>
									</div>
								</FormGroup>
							)}
						{/* <FormGroup>
                            <Label>Impressora</Label>
                            <SelectComponent options={props.impressoras}
                                placeholder="Selecione uma impressora para emissão do laudo"
                                onChange={(e) => props.atualizarImpressora(e)} value={props.impressora}
                            />
                        </FormGroup> */}
						<Row>
							<Col>
								<CheckBox
									label={
										<IntlMessage id="dashboard.resultsScreen.modal.examresult" />
									}
									onChange={props.changeResultadoExame}
									checked={props.entregarResultadoExame}
								></CheckBox>
							</Col>
							<Col>
								<CheckBox
									label={
										<IntlMessage id="dashboard.resultsScreen.modal.deliveryprotocol" />
									}
									onChange={props.changeImprimirProtocoloEntrega}
									checked={props.imprimirProtocoloEntrega}
								></CheckBox>
							</Col>
							<Col>
								<div
									style={{
										display: !props.imprimirProtocoloEntrega
											? 'none'
											: undefined,
									}}
								>
									{props.existeCasseteOuLamina && (
										<CheckBox
											label={
												<IntlMessage id="dashboard.resultsScreen.modal.delivermaterial" />
											}
											disabled={!props.imprimirProtocoloEntrega}
											onChange={props.changeEntregarMaterial}
											checked={props.entregarMaterial}
										></CheckBox>
									)}
								</div>
							</Col>
						</Row>
					</TabPane>
					<TabPane tabId="2">
						<div
							className="mv-entrega-container"
							style={{
								height: `${props.altura}px`,
								overflowY: 'scroll',
								overflowX: 'hidden',
							}}
						>
							{props.historicos.map((hist) => {
								return (
									<Row>
										<Col>
											<Card>
												<CardBody>
													<CardTitle>
														{hist.dataEntrega}
														{hist.entregaCancelada && (
															<span>
																<Badge
																	color="danger"
																	style={{
																		marginLeft: '15px',
																		fontSize: '11px',
																	}}
																>
																	<IntlMessage id="dashboard.resultsScreen.modal.deliverycanceled" />
																</Badge>
															</span>
														)}
													</CardTitle>
													<CardText>
														<Row>
															{hist.entregueViaPortal && (
																<Col style={{ minWidth: '80%' }}>
																	<IntlMessage id="dashboard.resultsScreen.modal.reportViewedBy" />
																	{` ${hist.entreguePor} `}
																	<IntlMessage id="dashboard.resultsScreen.modal.originPortal" />
																</Col>
															)}
															{!hist.entregueViaPortal && (
																<Col style={{ minWidth: '80%' }}>
																	<IntlMessage id="dashboard.resultsScreen.modal.deliveredby" />
																	{` ${hist.entreguePor} `}à
																	{` ${hist.responsavel} ${hist.cpfResponsavel ? `(${hist.cpfResponsavel})` : ''}`}
																</Col>
															)}
															<Col style={{ maxWidth: '20%' }}>
																{!hist.entregaCancelada && !hist.entregueViaPortal && (
																	<Button
																		className="btn-cancelar-entrega"
																		color="danger"
																		onClick={() =>
																			props.toggleModalCancelamentoEntrega(
																				hist.id
																			)
																		}
																	>
																		<IntlMessage id="dashboard.resultsScreen.modal.canceled" />
																	</Button>
																)}
															</Col>
														</Row>
													</CardText>
													{hist.observacao && (
														<div
															onClick={() => props.abrirFecharAnotacao(hist.id)}
														>
															<strong>
																<IntlMessage id="dashboard.resultsScreen.modal.internalnotes" />
																<i className="far fa-sticky-note"></i>
															</strong>
															<Collapsible
																open={hist.exibirAnotacoes}
																transitionTime={850}
															>
																<FormGroup>
																	<Input
																		disabled
																		type="textarea"
																		style={{
																			fontSize: '13px',
																			marginTop: '5px',
																		}}
																		name="anotacoesInternasEntregaExame"
																		value={hist.observacao}
																	/>
																</FormGroup>
															</Collapsible>
														</div>
													)}

													{hist.materiaisEntregues.map((matEntregue) => {
														return (
															<div
																key={matEntregue.id}
																style={{
																	display: 'flex',
																	flexDirection: 'column',
																	marginBottom: '20px',
																}}
															>
																<span>
																	<strong>
																		<IntlMessage id="dashboard.resultsScreen.modal.description" />
																	</strong>{' '}
																	{'  '}
																	{matEntregue.descricao}
																</span>
																<span>
																	<strong>
																		<IntlMessage id="dashboard.resultsScreen.modal.type" />
																	</strong>{' '}
																	{'  '}
																	{matEntregue.tipo}
																</span>
															</div>
														);
													})}
												</CardBody>
											</Card>
										</Col>
									</Row>
								);
							})}
						</div>
					</TabPane>
				</TabContent>
			</ModalBody>
			<ModalFooter>
				<Button color="secondary" onClick={props.closeModal}>
					<IntlMessage id="dashboards.disposalMaterials.modal.cancel" />
				</Button>
				{props.activeTab === '1' && (
					<Button
						color="primary"
						onClick={(e) => {
							if (props.entregarMaterial) {
								props.abrirSelecaoMaterial();
							} else {
								props.entregarExame();
							}
						}}
						disabled={
							!(
								!!props.exameEntregueA &&
								!!props.cpfResponsavel &&
								props.cpfResponsavel.length === 14 &&
								(props.entregarResultadoExame ||
									props.imprimirProtocoloEntrega) &&
								props.cpfValido
							)
						}
					>
						<IntlMessage id="dashboard.resultsScreen.modal.deliver" />
					</Button>
				)}
			</ModalFooter>
		</Modal>
	</div>
);



// WEBPACK FOOTER //
// ./src/pages/main/listagem/modais/entrega/modal.entrega.page.js